import { charsheetAPI } from '../globals.js';
import axios from 'axios';

// POST the Discord token plus the already-fetched /users/@me payload to Lambda.
// Lambda signs a JWT and returns it as an httpOnly Set-Cookie. Response body
// carries user data for UI bootstrap. No JWT is ever exposed to JavaScript.
const getAccessToken = async (discordToken, discordUser) => {
    const res = await axios.post(
        charsheetAPI + '?TableName=token-request',
        { discordToken, discordUser },
        { withCredentials: true }
    );
    return res.data;
};

export default getAccessToken;
